import { Box, IconButton, Typography } from '@mui/material'
import { useState } from 'react'
import {
  ACTIVITY_TYPES,
  CURRENCY_COUNTRY_CODE,
  FIELD_TYPES,
  FORMATS,
  STANDARD_COLORS,
} from '../../../utility/constants'
import { fileServices } from '../../../services/fileServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { getFieldId, getKeyOfValue } from '../../../pages/DataEntryPage/utils/utils'
import LongMenu from '../../../pages/DataEntryPage/Fields/LongMenu'
import StandaloneFilePreview from '../../Dashboard/PreviewComponent/components/StandaloneFilePreview'
import { extractDisplayName } from '../../../utility/fileUtil'
import FieldHistory from '../../DataEntry/FieldHistory'
import { formatCurrency } from '../../../pages/DataEntryPage/utils/currency'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'

import { getDateAndDateTime } from '../util'
import moment from 'moment'
import { formatUserFullName } from '../../../utility/userName'

const NormalFieldPreview = ({
  activityType,
  field,
  value,
  review,
  comment,
  index,
  previewCurrency,
  listData,
  dynamicListData,
  processId,
  data,
  isPreview = false,
  defaultCurrency = {},
}) => {
  const { user } = useAuthContext()
  const [filePreview, setFilePreview] = useState(null)

  const downloadFile = async (value) => {
    await fileServices.downloadFile(user, value)
  }

  const renderValue = (field) => {
    if (field.data_structure === FIELD_TYPES.CURRENCY) {
      return formatCurrency(
        value,
        getKeyOfValue(CURRENCY_COUNTRY_CODE, previewCurrency[field.id]),
        {
          defaultCurrency: defaultCurrency,
        }
      )
    } else if (
      field.data_structure === FIELD_TYPES.DATE ||
      field.data_structure === FIELD_TYPES.DATETIME
    ) {
      return getDateAndDateTime(value, field.data_structure)
    } else if (field.data_structure === FIELD_TYPES.FILE && value) {
      return extractDisplayName(value)
    } else if (field.data_structure === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
      if (!value || !value.length) return ''

      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {value.map((v, index) => {
            const user = dynamicListData?.users?.find((u) => u.id === v.user_id)
            const username = user ? formatUserFullName(user) : null
            const text = typeof v.text === 'string' ? v.text.trimStart() : v.text

            return (
              <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <span style={{ fontWeight: 600 }}>{`${moment(v?.timestamp).format(
                  FORMATS.DATETIME
                )}:`}</span>{' '}
                {text}
                <span style={{ fontStyle: 'italic', color: '#888' }}>{` - ${username}`}</span>
              </div>
            )
          })}
        </div>
      )
    } else if (field.data_structure == FIELD_TYPES.BIGTEXT) {
      return <span style={{ position: 'relative' }}>{value}</span>
    } else {
      return <span style={{ position: 'relative' }}>{value}</span>
    }
  }

  return (
    <div className="preview-field-class" style={{ marginBottom: 8 }}>
      <Box
        id={getFieldId(field.id)}
        style={{
          display: 'flex',
          flexDirection: 'row',
          fontSize: 14,
          padding: '4px 8px',
          backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'transparent',
          borderRadius: 4,
          border: '1px solid #e1d9fb',
          width: '100%',
          gap: 8,
          alignItems: 'center',
          overflowX: 'hidden',
        }}
      >
        <div style={{ width: '40%', marginBottom: 0, minWidth: 0 }}>
          <Typography style={{ fontSize: '14px' }}>
            {field.field_template_name}
            {field.is_required ? '*' : ''}
          </Typography>
        </div>

        <div
          style={{
            width: '60%',
            marginBottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minWidth: 0,
            overflowX: 'hidden',
          }}
        >
          <FieldHistory
            className="previewfieldhostory"
            fieldId={field.id}
            field={field}
            listDataMetadata={listData}
            dynamicListData={dynamicListData}
            processId={processId}
            allValues={data}
            isPreview={isPreview}
            width="auto"
          >
            <Typography
              style={{
                fontSize: 14,
                whiteSpace: 'pre-line',
                fontWeight: '500',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',

                color:
                  activityType === ACTIVITY_TYPES.REVIEW
                    ? review === undefined
                      ? null
                      : review
                      ? STANDARD_COLORS.PREVIEW_ACCEPTED
                      : STANDARD_COLORS.PREVIEW_REJECTED
                    : activityType === ACTIVITY_TYPES.LONG_RUNNING
                    ? review === true
                      ? STANDARD_COLORS.PREVIEW_ACCEPTED
                      : STANDARD_COLORS.PREVIEW_REJECTED
                    : null,
              }}
            >
              {renderValue(field)}
            </Typography>
          </FieldHistory>
          {field.data_structure === FIELD_TYPES.FILE && value && (
            <LongMenu
              options={[
                {
                  label: 'Preview',
                  icon: (
                    <IconButton size="small" sx={{ padding: '0px 4px' }}>
                      <RemoveRedEyeOutlinedIcon fontSize="18px" />
                    </IconButton>
                  ),
                  onClick: () => setFilePreview(value),
                },
                {
                  label: 'Download',
                  icon: (
                    <IconButton size="small" sx={{ padding: '0px 4px' }}>
                      <FileDownloadOutlinedIcon fontSize="18px" />
                    </IconButton>
                  ),
                  onClick: () => downloadFile(value),
                },
              ]}
            />
          )}
        </div>
      </Box>
      <StandaloneFilePreview
        fileKey={filePreview}
        open={filePreview != null}
        onClose={() => setFilePreview(null)}
      />
    </div>
  )
}

export default NormalFieldPreview
